module.exports = __webpack_public_path__ + "img/newspaper-folding.4f13cd7a.svg";